import { DerivitaEnvironment } from 'derivita/ts/environment/environment_service';

declare interface DerivitaWindow extends Window {
  derivita: DerivitaEnvironment;
}

export function getWindowDerivitaEnvironment(
  win: Window = window
): DerivitaEnvironment {
  const dwindow = win as unknown as DerivitaWindow;
  dwindow.derivita = dwindow.derivita ?? {};
  return dwindow.derivita;
}
